import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { routes } from 'flow/types/routes';
import { getWallboardUrlPathKeyFromBoardType } from 'flow/utils/wallboard-utils';
import useAppContext from 'flow/hooks/useAppContext';
import Page from 'flow/components/Setting/Page';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { generatePath } from 'flow/utils/router-utils';
import DashboardTemplatePicker from './DashboardTemplatePicker';

const DashboardTemplates = () => {
    const history = useHistory();
    const { i18next } = useAppContext();
    const { extensionKey } = useParams<{ extensionKey: ExtensionKey }>();

    const navigateToCreateTemplate = (type: string) => {
        history.push(
            generatePath(routes['settings.dashboards.create'], {
                wallboardTypePath: getWallboardUrlPathKeyFromBoardType(type),
            }),
        );
    };

    return (
        <Page
            header={i18next.t('wallboard.create_new')}
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.dashboards'], {
                        extensionKey,
                    }),
                )
            }
        >
            <DashboardTemplatePicker
                onTemplateSelection={navigateToCreateTemplate}
            />
        </Page>
    );
};

export default React.memo(DashboardTemplates);
